import * as actionTypes from "Redux/Actions/actionTypes";

const initialState = {
  loading: [], // array of loading keys (strings)
  message: "",
};

const ProgressIndicatorReducer = (state = initialState, action) => {
  console.log("Reducer received action:", action);

  // Ensure id is always a valid non-empty string or fallback
  const id =
    typeof action.loading === "string" && action.loading.trim() !== ""
      ? action.loading
      : "GENERIC_LOADING";

  switch (action.type) {
    case actionTypes.LOADING_START:
      return {
        ...state,
        loading: state.loading.includes(id)
          ? state.loading
          : [...state.loading, id],
        message:
          typeof action.message === "string" && action.message.trim() !== ""
            ? action.message
            : "Processing...",
      };

    case actionTypes.LOADING_FINISH:
      return {
        ...state,
        loading: state.loading.filter((item) => item !== id),
        // Clear message only if no more loading keys remain
        message: state.loading.length === 1 ? "" : state.message,
      };

    default:
      return state;
  }
};

export default ProgressIndicatorReducer;
